import { render } from "./monitoring.vue?vue&type=template&id=66fafdec&scoped=true&ts=true"
import script from "./monitoring.vue?vue&type=script&lang=ts&config=true"
export * from "./monitoring.vue?vue&type=script&lang=ts&config=true"

import "./monitoring.vue?vue&type=style&index=0&id=66fafdec&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66fafdec"]])

export default __exports__